import { useTranslation } from "react-i18next";
import PageHero from "@/components/layout/PageHero";
import { VisualSection } from "@/components/layout/visualLayout";
import SectionIntro from "@/components/layout/SectionIntro";
import NewsletterForm from "@/components/common/NewsletterForm";
import Reveal from "@/components/common/Reveal";
import HoverGlow from "@/components/motion/HoverGlow";

const filterKeys = [
  "filterAll",
  "filterAI",
  "filterWomen",
  "filterStartup",
  "filterInvestor",
  "filterInterviews",
  "filterEvents",
  "filterPersonal",
];

export default function Content() {
  const { t } = useTranslation();

  return (
    <div data-testid="page-content">
      <PageHero
        eyebrow={t("content.eyebrow")}
        title={t("content.title")}
        subtitle={t("content.lead")}
        testId="content-hero"
      />

      <VisualSection testId="content-main">
        <Reveal>
          <div className="mb-10" data-testid="content-filters">
            <p className="wit-eyebrow text-raspberry mb-3">{t("content.filtersLabel")}</p>
            <div
              className="flex flex-wrap gap-2 opacity-60"
              aria-label={t("content.filtersLabel")}
              role="group"
            >
              {filterKeys.map((k) => (
                <span
                  key={k}
                  aria-disabled="true"
                  className="wit-pill bg-white border-sandBeige text-ink cursor-default"
                  data-testid={`content-filter-${k}`}
                >
                  {t(`content.${k}`)}
                </span>
              ))}
            </div>
            <p className="mt-3 text-sm text-warmGrey">{t("content.filtersComingSoon")}</p>
          </div>
        </Reveal>

        <Reveal delay={0.08}>
          <HoverGlow>
            <div className="wit-card text-center py-12 sm:py-14 flex flex-col items-center gap-5" data-testid="content-empty">
              <SectionIntro
                title={t("content.emptyTitle")}
                subtitle={t("content.emptyBody")}
                center
                className="mb-2"
              />
              <NewsletterForm testId="content-newsletter" />
            </div>
          </HoverGlow>
        </Reveal>
      </VisualSection>
    </div>
  );
}
